// extracted by mini-css-extract-plugin
export var container = "feature-list-module--container--mbS5E";